<app-toolbar></app-toolbar>

<div class="gdl-container">
  <!-- Header con botón de refresh -->
  <div class="header">
    <div>
      <h1>ECS Software Engineering Projects</h1>
    </div>

    <button
      class="refresh-button"
      (click)="refreshData()"
      [disabled]="isRefreshing"
      [class.refreshing]="isRefreshing"
      title="Refresh data"
    >
      <span class="icon" [class.spinning]="isRefreshing">⟳</span>
      <span *ngIf="!isRefreshing">Refresh</span>
      <span *ngIf="isRefreshing">Refreshing...</span>
    </button>
  </div>

  <!-- Loading state (solo primera carga sin caché) -->
  <div class="loading-state" *ngIf="isInitialLoading">
    <div class="spinner"></div>
    <p>Loading projects...</p>
  </div>

  <!-- Tabla de datos -->
  <app-tabla *ngIf="!isInitialLoading" [ec2Repositories]="demo"></app-tabla>

  <!-- Empty state -->
  <div class="empty-state" *ngIf="!isInitialLoading && demo.length === 0">
    <p>No projects found</p>
    <button (click)="refreshData()">Try Again</button>
  </div>
</div>
